import React from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

interface TablePaginationProps {
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
}

/**
 * Compact Odoo-style pagination control.
 * Renders: "1-80 / 271  < >"
 */
export const TablePagination: React.FC<TablePaginationProps> = ({
  page,
  pageSize,
  totalCount,
  onPageChange,
  isLoading = false,
}) => {
  const start = Math.min((page - 1) * pageSize + 1, totalCount);
  const end = Math.min(page * pageSize, totalCount);
  const totalPages = Math.ceil(totalCount / pageSize);

  const canGoPrev = page > 1;
  const canGoNext = page < totalPages;

  if (totalCount === 0) return null;

  return (
    <div className="flex items-center gap-1.5 select-none">
      <span className="text-muted-foreground text-sm whitespace-nowrap tabular-nums">
        {start}-{end} / {totalCount}
      </span>
      <button
        onClick={() => canGoPrev && onPageChange(page - 1)}
        disabled={!canGoPrev || isLoading}
        className="border-border text-muted-foreground hover:bg-muted hover:text-foreground inline-flex h-7 w-7 items-center justify-center rounded border transition-colors disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent"
        aria-label="Vorige pagina"
      >
        <CaretLeft size={14} weight="bold" />
      </button>
      <button
        onClick={() => canGoNext && onPageChange(page + 1)}
        disabled={!canGoNext || isLoading}
        className="border-border text-muted-foreground hover:bg-muted hover:text-foreground inline-flex h-7 w-7 items-center justify-center rounded border transition-colors disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent"
        aria-label="Volgende pagina"
      >
        <CaretRight size={14} weight="bold" />
      </button>
    </div>
  );
};
